import React, { useContext } from 'react'
import './Admin_nav.css'
import logo from '../../assets/frontend_assets/logo.png';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../Context/UserContext';

function Admin_nav() {


    const { logout } = useUser();
    const navigate = useNavigate();


     const handleLogout = () => {
    logout(); // Clear user data from context and localStorage
      setTimeout(() => {
    navigate('/'); // Change this to your desired route
  }, 1000);
  };

    
  return (
    <div className='admin_nav_container'>
        <div className="nav_logo">
                <img src={logo} alt="logo" />
                <p>Admin Panel</p>
              </div>
              
               <div className="nav_logout">
                <button onClick={handleLogout}>Log-out</button>
              </div>
    </div>
  )
}

export default Admin_nav